<!--
 * @Description: 
 * @Author: pliybird
 * @Date: 2023-05-25 14:11:17
 * @LastEditTime: 2023-07-20 17:18:29
 * @LastEditors: 陈绍斌 1748362428@qq.com
 * @filePath: Do not edit
-->
<!-- 汽配解决方案模块 -->

<template>
  <div class="auto_solution_box" :class="{'auto_solution_box_en':$i18n.locale === 'en_US','auto_solution_box_ja': $i18n.locale === 'ja_JP'}">
    <div class="auto_solution_content">
      <div class="sheets_box row">
        <div class="col-lg-8 col-md-12 col-sm-12 col-12 left_img">
          <div
            class="left_sheet"
            :style="{
              'background-image': 'url(' + bgData + ')',
              backgroundSize: '100% 100%',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center center',
            }"
          >
            <div class="text_color box-body-top d-flex">
              <div>{{ $t("solution.automobile.solutions.image.tab01.process01") }}</div>
              <div> {{ $t("solution.automobile.solutions.image.tab01.process02") }} </div>
              <div >{{ $t("solution.automobile.solutions.image.tab01.process03") }}</div>
              <div>{{ $t("solution.automobile.solutions.image.tab01.process04") }}</div>
            </div>
            <div class="text_normal" style="top: 12%; left: 20.5%">
              {{ $t("solution.automobile.solutions.image.tab01.process05") }}
            </div>
            <div class="text_normal" style="top: 22.5%; left: 20.5%">
              {{ $t("solution.automobile.solutions.image.tab01.process06") }}
            </div>
            <div class="text_normal" style="top: 22.5%; left: 43.5%">
              {{ $t("solution.automobile.solutions.image.tab01.process07") }}
            </div>
            <div class="text_normal" style="top: 25%; left: 86.5%">
              {{ $t("solution.automobile.solutions.image.tab01.process08") }}
            </div>
            <div class="text_normal" style="top: 41%; left: 1%">
              {{ $t("solution.automobile.solutions.image.tab01.process16") }}
            </div>
            <div class="text_normal" style="top: 55.8%; left: 1%">
              {{ $t("solution.automobile.solutions.image.tab01.process15") }}
            </div>
            <div class="text_normal" style="top: 56%; left: 86.5%">
              {{ $t("solution.automobile.solutions.image.tab01.process09") }}
            </div>
            <div class="text_color box-body-foot">
              <div>
                {{ $t("solution.automobile.solutions.image.tab01.process14") }}
              </div>
              <div>
                {{ $t("solution.automobile.solutions.image.tab01.process13") }}
              </div>
              <div>
                {{ $t("solution.automobile.solutions.image.tab01.process12") }}
              </div>
              <div>
                {{ $t("solution.automobile.solutions.image.tab01.process11") }}
              </div>
              <div>
                {{ $t("solution.automobile.solutions.image.tab01.process10") }}
              </div>
            </div>

            <div class="text_blue position-absolute" style="top: 40%; left: 66%">
              {{ $t("solution.automobile.solutions.image.tab02.process01") }}
            </div>

            <div class="box-body-center d-flex flex-wrap">
              <div class="text_blue">
                {{ $t("solution.automobile.solutions.image.tab02.process05") }}
              </div>
              <div class="text_blue">
                {{ $t("solution.automobile.solutions.image.tab02.process04") }}
              </div>
              <div class="text_blue">
                {{ $t("solution.automobile.solutions.image.tab02.process03") }}
              </div>
              <div class="text_blue">
                {{ $t("solution.automobile.solutions.image.tab02.process02") }}
              </div>
              <div class="text_blue">
                {{ $t("solution.automobile.solutions.image.tab02.process06") }}
              </div>
              <div class="text_blue">
                {{ $t("solution.automobile.solutions.image.tab02.process07") }}
              </div>
              <div class="text_blue">
                {{ $t("solution.automobile.solutions.image.tab02.process08") }}
              </div>
              <div class="text_blue">
                {{ $t("solution.automobile.solutions.image.tab02.process09") }}
              </div>
            </div>

            <div class="text_white_title" style="top: 36%; left: 24.5%">
              {{ $t("solution.automobile.solutions.image.tab02.title") }}
            </div>
            <div class="text_white" style="top: 45%; left: 24.5%">
              {{ $t("solution.automobile.solutions.image.tab02.desc01") }}
            </div>
            <div class="text_white" style="top: 45%; left: 38%">
              {{ $t("solution.automobile.solutions.image.tab02.desc02") }}
            </div>
            <div class="text_white" style="top: 45%; left: 52%">
              {{ $t("solution.automobile.solutions.image.tab02.desc03") }}
            </div>
          </div>
        </div>
        <!--  class="right_sheet" -->
        <div class="col-lg-4 col-md-12 col-sm-12 col-12 mt_sm--30">
          <div class="right_sheet">
            <div class="text_desc_box">
              <div class="img_box">
                <img
                  :src="
                    require('../../../../assets/images/IndustrySolution/automobileSolutions/textIcon.png')
                  "
                  alt=""
                />
              </div>
              <div class="desc_text">
                {{ $t("solution.automobile.solutions.card.description1") }}
              </div>
            </div>
            <div class="text_desc_box">
              <div class="img_box">
                <img
                  :src="
                    require('../../../../assets/images/IndustrySolution/automobileSolutions/textIcon.png')
                  "
                  alt=""
                />
              </div>
              <div class="desc_text">
                {{ $t("solution.automobile.solutions.card.description2") }}
              </div>
            </div>
            <div class="text_desc_box">
              <div class="img_box">
                <img
                  :src="
                    require('../../../../assets/images/IndustrySolution/automobileSolutions/textIcon.png')
                  "
                  alt=""
                />
              </div>
              <div class="desc_text">
                {{ $t("solution.automobile.solutions.card.description3") }}
              </div>
            </div>
            <div class="text_desc_box">
              <div class="img_box">
                <img
                  :src="
                    require('../../../../assets/images/IndustrySolution/automobileSolutions/textIcon.png')
                  "
                  alt=""
                />
              </div>
              <div class="desc_text">
                {{ $t("solution.automobile.solutions.card.description4") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'AutomobileSolutions',
  components: {},
  data () {
    return {
      bgData: require('@/assets/images/IndustrySolution/automobileSolutions/automobileSolutions_bg.png')
    }

  },
  methods: {

  }
}
</script>